import ProfileCard from "widgets/cards/profile";
import ComboBox from "widgets/shared/inputs/combobox";
import InputField from "widgets/shared/inputs/inputField";
  import MultiCombobox from "widgets/shared/inputs/multiselectCombobox";
import PinInputs from "widgets/shared/inputs/pinInput";
import { SearchInput } from "widgets/shared/inputs/search";
import ExampleForm from "./components/form";
import GenericButton from "widgets/controls/buttons/generic";
import { notifySimple } from "providers/toast";
import LabeledField from "providers/labeledField";
import GenericCard from "widgets/cards/generic";
import CircleButton from "widgets/controls/buttons/circle-button";
import { MdAdd } from "react-icons/md";
import { StatusDropdown } from "models/dropdowns/status";
import DateRangePickerField from "widgets/shared/inputs/dateRangePicker";
import Checkbox from "widgets/shared/inputs/checkbox";
import Switch from "widgets/shared/inputs/switch";
import DatePickerField from "widgets/shared/inputs/datePicker";
import Radio from "widgets/shared/inputs/radio";
import { useState } from "react";
import PhoneInput from "widgets/shared/inputs/phone";

const Widgets = () => {
  const [inputField, setInputField] = useState("");
  return (
    <div className="mt-6 grid h-full w-full grid-cols-1 gap-y-4 lg:grid-cols-2 lg:gap-x-4 lg:gap-y-4">
      <GenericCard title="Inputs" description="Example inputs" bgColor="white">
        <div className="flex flex-col gap-4">
        <LabeledField label={"InputField"} id={"pin"} className="heading-md" >
        <div className="flex gap-1 py-2">
        <InputField
              id={"1"}
              placeholder="large..."
                sizes="md"
              onChange={(e) => {
                setInputField(e);
              }}
              value={inputField}
              secure
            />
            <InputField
              id={"1"}
              placeholder="large..."
                sizes="md"
                variant="solid"
              onChange={(e) => {
                setInputField(e);
              }}
              value={inputField}
            />
           
          </div>
          <div className="flex gap-1 py-2 bg-gray-800">
          <InputField
              id={"1"}
              placeholder="medium..."
              sizes="md"
              onChange={(e) => {
                setInputField(e);
              }}
              value={inputField}
              color="secondary"
            />
             <InputField
              id={"1"}
              placeholder="medium..."
              sizes="md"
              variant="solid"
              onChange={(e) => {
                setInputField(e);
              }}
              value={inputField}
              color="secondary"
            />
           
          </div>
          </LabeledField>
          <LabeledField label={"Combobox"} id={"pin"} className="heading-md">
          <div className="z-20 flex gap-1 py-2">
          <ComboBox
              id={"1"}
              placeholder="large..."
             sizes="md"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
            />
            <ComboBox
              id={"1"}
              placeholder="large..."
              variant="solid"
             sizes="md"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
            />
           
           
          </div>
          <div className="z-20 flex gap-1 py-2 bg-gray-800">
            <ComboBox
              id={"1"}
              placeholder="medium..."
              sizes="md"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
              color="secondary"
            />
             <ComboBox
              id={"1"}
              placeholder="medium..."
              sizes="md"
              variant="solid"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
              color="secondary"
            />
          </div>
          </LabeledField>
          <LabeledField label={"Multi Combobox"} id={"pin"} className="heading-md">
          <div className="flex gap-1 py-2">
            <MultiCombobox
              id={"1"}
              placeholder="large..."
              sizes="md"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
              filter
              selectAll
            />
            <MultiCombobox
              id={"1"}
              placeholder="medium..."
              sizes="md"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
              filter
              selectAll
              variant="solid"
            />
          </div>
          <div className="flex gap-1 py-2 bg-gray-800">
            <MultiCombobox
              id={"1"}
              placeholder="large..."
              sizes="md"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
              filter
              selectAll
              color="secondary"
            />
            <MultiCombobox
              id={"1"}
              placeholder="medium..."
              sizes="md"
              value={undefined}
              onChange={() => {}}
              items={StatusDropdown}
              minWidth="w-full"
              filter
              selectAll
              color="secondary"
              variant="solid"
            />
          </div>
          </LabeledField>
          <LabeledField label={"Date Range Picker"} id={"pin"} className="heading-md">
          <div className="flex gap-1 py-2">
            <DateRangePickerField id={""} sizes="md" />
            <DateRangePickerField id={""} sizes="md" variant="solid" />
          </div>
          <div className="flex gap-1 py-2 bg-gray-800">
            <DateRangePickerField id={""} sizes="md" color="secondary" />
            <DateRangePickerField id={""} sizes="md" variant="solid" color="secondary" />
          </div>
          <div className="flex gap-1 py-2">
            <DateRangePickerField id={""} sizes="sm" iconOnly />
            <DateRangePickerField id={""} sizes="sm" iconOnly color="secondary" />
          </div>
          </LabeledField>
         <LabeledField label={"Date Picker"} id={"pin"} className="heading-md">
         <div className="flex gap-1 py-2">
            <DatePickerField id={""} sizes="md" />
            <DatePickerField id={""} sizes="md" variant="solid" />
          </div>
          <div className="flex gap-1 py-2 bg-gray-800">
            <DatePickerField id={""} sizes="md" color="secondary" />
            <DatePickerField id={""} sizes="md" variant="solid" color="secondary" />
          </div>
          <div className="flex gap-1 py-2">
            <DatePickerField id={""} sizes="sm" iconOnly />
            <DatePickerField id={""} sizes="sm" iconOnly color="secondary" />
          </div>
         </LabeledField>
         <LabeledField label={"Search Input"} id={"pin"} className="heading-md">
          <div className="flex gap-1 py-2">
              <SearchInput value={undefined} onChange={() => {}} sizes="md" variant="outline" />
              <SearchInput value={undefined} onChange={() => {}} sizes="md" />
            </div>
            <div className="flex gap-1 py-2 bg-gray-800">
              <SearchInput value={undefined} onChange={() => {}} sizes="md" variant="outline" color="secondary" />
              <SearchInput value={undefined} onChange={() => {}} sizes="md" color="secondary" />
            </div>
         </LabeledField>
         <LabeledField label={"Checkbox"} id={"pin"} className="heading-md">
            <div className="flex gap-1 py-2">
              <Checkbox sizes="xl" onChange={() => {}} labelKey="hello" />
              <Checkbox sizes="lg" onChange={() => {}} labelKey="hello" labelPosition="left" />
              <Checkbox sizes="md" onChange={() => {}} labelKey="hello" color="teal" />
            </div>
            <div className="flex gap-1 py-2">
              <Checkbox sizes="xl" onChange={() => {}} labelKey="hello" color="secondary" />
              <Checkbox sizes="lg" onChange={() => {}} labelKey="hello"  labelPosition="left" color="secondary" />
              <Checkbox sizes="md" onChange={() => {}} labelKey="hello"  color="secondary" />
            </div>
          </LabeledField>
          <LabeledField label={"Switch"} id={"pin"} className="heading-md">
          <div className="flex gap-1 py-2">
            <Switch sizes="lg" onChange={() => {}} labelKey="hello" />
            <Switch sizes="lg" onChange={() => {}} labelKey="hello" color="teal" />
            <Switch sizes="md" onChange={() => {}} labelKey="hello" labelPosition="left" />
          </div>
          <div className="flex gap-1 py-2 bg-gray-800">
            <Switch sizes="lg" onChange={() => {}} labelKey="hello" color="secondary" />
            <Switch sizes="md" onChange={() => {}} labelKey="hello"  labelPosition="left" color="secondary" />
          </div>
          </LabeledField>
          <LabeledField label={"Radio"} id={"pin"} className="heading-md">
          <div className="flex gap-1 py-2">
            <Radio onChange={() => {}} sizes="xl" labelKey="hello" />
            <Radio onChange={() => {}} sizes="xl" labelKey="hello" color="teal" />
            <Radio onChange={() => {}} sizes="lg" labelKey="hello" labelPosition="left" />
          </div>
          <div className="flex gap-1 py-2">
            <Radio onChange={() => {}} sizes="xl" labelKey="hello" color="secondary" />
            <Radio onChange={() => {}} sizes="lg" labelKey="hello"  labelPosition="left" color="secondary" />
          </div>
          </LabeledField>
          <LabeledField label={"Pin Inputs"} id={"pin"} className="heading-md">
          <div className="flex gap-1 py-2">
              <PinInputs value={undefined} onChange={undefined} />
              <PinInputs value={undefined} onChange={undefined} variant="solid" />
            </div>
            <div className="flex gap-1 py-2 bg-gray-800">
              <PinInputs value={undefined} onChange={undefined} color="secondary" />
              <PinInputs value={undefined} onChange={undefined} color="secondary" variant="solid" />
            </div>
          </LabeledField>
        <LabeledField label={"Phone Number"} id={"pin"} className="heading-md">
        <div className="flex gap-1 py-2">
            <PhoneInput id={""} value={""} onChange={() => {}} sizes="md" />
            <PhoneInput id={""} value={""} onChange={() => {}} sizes="md" variant="solid" />
          </div>
          <div className="flex gap-1 py-2 bg-gray-800">
            <PhoneInput id={""} value={""} onChange={() => {}} sizes="md" color="secondary" />
            <PhoneInput id={""} value={""} onChange={() => {}} sizes="md" color="secondary" variant="solid" />
          </div>
        </LabeledField>
          
     </div>
      </GenericCard>
      <ProfileCard title="Form" description="Example">
        <ExampleForm
          submit={(value) => {
            console.log(value);
          }}
        />
      </ProfileCard>
      <GenericCard title="Buttons" description="Example buttons">
        <LabeledField
          label={"Primary Buttons - Standard:"}
          id={"primary-buttons"}
          className="heading-md "
        >
          <div className="flex flex-col gap-2 py-2">
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"solid"}
              size="xs"
              text={"Solid - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"solid"}
              size="sm"
              text={"Solid - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"solid"}
              size="md"
              text={"Solid - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"solid"}
              size="lg"
              text={"Solid - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"outline"}
              size="xs"
              text={"Outline - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"outline"}
              size="sm"
              text={"Outline - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"outline"}
              size="md"
              text={"Outline - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"outline"}
              size="lg"
              text={"Outline - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"ghost"}
              size="xs"
              text={"Ghost - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"ghost"}
              size="sm"
              text={"Ghost - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"ghost"}
              size="md"
              text={"Ghost - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"ghost"}
              size="lg"
              text={"Ghost - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"link"}
              size="xs"
              text={"Link - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"link"}
              size="sm"
              text={"Link - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"link"}
              size="md"
              text={"Link - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"link"}
              size="lg"
              text={"Link - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          </div>
        </LabeledField>
        <LabeledField
          label={"Secondary Buttons - Standard:"}
          id={"primary-buttons"}
          className="heading-md "
        >
            <div className="flex flex-col gap-2 py-2">
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"solid"}
              size="xs"
              text={"Solid - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"solid"}
              size="sm"
              text={"Solid - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"solid"}
              size="md"
              text={"Solid - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"solid"}
              size="lg"
              text={"Solid - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
              color="secondary"
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"outline"}
              size="xs"
              text={"Outline - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"outline"}
              size="sm"
              text={"Outline - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"outline"}
              size="md"
              text={"Outline - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"outline"}
              size="lg"
              text={"Outline - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
              color="secondary"
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"ghost"}
              size="xs"
              text={"Ghost - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"ghost"}
              size="sm"
              text={"Ghost - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"ghost"}
              size="md"
              text={"Ghost - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"ghost"}
              size="lg"
              text={"Ghost - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
              color="secondary"
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"link"}
              size="xs"
              text={"Link - xs"}
              onClick={() => {
                notifySimple("Success", "info");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"link"}
              size="sm"
              text={"Link - sm"}
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"link"}
              size="md"
              text={"Link - md"}
              onClick={() => {
                notifySimple("Error", "error");
              }}
              color="secondary"
            />
            <GenericButton
              variant={"link"}
              size="lg"
              text={"Link - lg"}
              onClick={() => {
                notifySimple("Success", "success");
              }}
              color="secondary"
            />
          </div>
          </div>
        </LabeledField>
        <LabeledField
          label={"Tertiary Buttons - Standard:"}
          id={"tertiary-buttons"}
          className="heading-md "
        >
          <div className="flex flex-col gap-2 py-2">
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"solid"}
              size="xs"
              text={"Solid - xs"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"solid"}
              size="sm"
              text={"Solid - sm"}
              color="tertiary"
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"solid"}
              size="md"
              text={"Solid - md"}
              color="tertiary"
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"solid"}
              size="lg"
              text={"Solid - lg"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"outline"}
              size="xs"
              text={"Outline - xs"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"outline"}
              size="sm"
              text={"Outline - sm"}
              color="tertiary"
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"outline"}
              size="md"
              text={"Outline - md"}
              color="tertiary"
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"outline"}
              size="lg"
              text={"Outline - lg"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"ghost"}
              size="xs"
              text={"Ghost - xs"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"ghost"}
              size="sm"
              text={"Ghost - sm"}
              color="tertiary"
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"ghost"}
              size="md"
              text={"Ghost - md"}
              color="tertiary"
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"ghost"}
              size="lg"
              text={"Ghost - lg"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          <div className="grid grid-cols-4 gap-5">
            <GenericButton
              variant={"link"}
              size="xs"
              text={"Link - xs"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "info");
              }}
            />
            <GenericButton
              variant={"link"}
              size="sm"
              text={"Link - sm"}
              color="tertiary"
              onClick={() => {
                notifySimple("Warning", "warning");
              }}
            />
            <GenericButton
              variant={"link"}
              size="md"
              text={"Link - md"}
              color="tertiary"
              onClick={() => {
                notifySimple("Error", "error");
              }}
            />
            <GenericButton
              variant={"link"}
              size="lg"
              text={"Link - lg"}
              color="tertiary"
              onClick={() => {
                notifySimple("Success", "success");
              }}
            />
          </div>
          </div>
        </LabeledField>
        <LabeledField
  label={"White Buttons - Standard:"}
  id={"white-buttons"}
  className="heading-md "
>
  <div className="flex flex-col gap-2 py-2 bg-gray-800">
    <div className="grid grid-cols-4 gap-5">
      <GenericButton
        variant={"solid"}
        size="xs"
        text={"Solid - xs"}
        color="white"
        onClick={() => {
          notifySimple("Success", "info");
        }}
      />
      <GenericButton
        variant={"solid"}
        size="sm"
        text={"Solid - sm"}
        color="white"
        onClick={() => {
          notifySimple("Warning", "warning");
        }}
      />
      <GenericButton
        variant={"solid"}
        size="md"
        text={"Solid - md"}
        color="white"
        onClick={() => {
          notifySimple("Error", "error");
        }}
      />
      <GenericButton
        variant={"solid"}
        size="lg"
        text={"Solid - lg"}
        color="white"
        onClick={() => {
          notifySimple("Success", "success");
        }}
      />
    </div>
    <div className="grid grid-cols-4 gap-5">
      <GenericButton
        variant={"outline"}
        size="xs"
        text={"Outline - xs"}
        color="white"
        onClick={() => {
          notifySimple("Success", "info");
        }}
      />
      <GenericButton
        variant={"outline"}
        size="sm"
        text={"Outline - sm"}
        color="white"
        onClick={() => {
          notifySimple("Warning", "warning");
        }}
      />
      <GenericButton
        variant={"outline"}
        size="md"
        text={"Outline - md"}
        color="white"
        onClick={() => {
          notifySimple("Error", "error");
        }}
      />
      <GenericButton
        variant={"outline"}
        size="lg"
        text={"Outline - lg"}
        color="white"
        onClick={() => {
          notifySimple("Success", "success");
        }}
      />
    </div>
    <div className="grid grid-cols-4 gap-5">
      <GenericButton
        variant={"ghost"}
        size="xs"
        text={"Ghost - xs"}
        color="white"
        onClick={() => {
          notifySimple("Success", "info");
        }}
      />
      <GenericButton
        variant={"ghost"}
        size="sm"
        text={"Ghost - sm"}
        color="white"
        onClick={() => {
          notifySimple("Warning", "warning");
        }}
      />
      <GenericButton
        variant={"ghost"}
        size="md"
        text={"Ghost - md"}
        color="white"
        onClick={() => {
          notifySimple("Error", "error");
        }}
      />
      <GenericButton
        variant={"ghost"}
        size="lg"
        text={"Ghost - lg"}
        color="white"
        onClick={() => {
          notifySimple("Success", "success");
        }}
      />
    </div>
    <div className="grid grid-cols-4 gap-5">
      <GenericButton
        variant={"link"}
        size="xs"
        text={"Link - xs"}
        color="white"
        onClick={() => {
          notifySimple("Success", "info");
        }}
      />
      <GenericButton
        variant={"link"}
        size="sm"
        text={"Link - sm"}
        color="white"
        onClick={() => {
          notifySimple("Warning", "warning");
        }}
      />
      <GenericButton
        variant={"link"}
        size="md"
        text={"Link - md"}
        color="white"
        onClick={() => {
          notifySimple("Error", "error");
        }}
      />
      <GenericButton
        variant={"link"}
        size="lg"
        text={"Link - lg"}
        color="white"
        onClick={() => {
          notifySimple("Success", "success");
        }}
      />
    </div>
  </div>
</LabeledField>
        <LabeledField
          label={"Circle Buttons - Primary:"}
          id={"primary-buttons"}
          className="heading-md "
        >
          <div className="flex flex-col gap-2 py-2">
          <div className="flex gap-4">
            <CircleButton icon={MdAdd} size="xs" />
            <CircleButton icon={MdAdd} size="sm" />
            <CircleButton icon={MdAdd} size="md" />
            <CircleButton icon={MdAdd} size="lg" />
          </div>
          <div className="flex gap-4">
            <CircleButton icon={MdAdd} size="xs" variant="outline" />
            <CircleButton icon={MdAdd} size="sm" variant="outline" />
            <CircleButton icon={MdAdd} size="md" variant="outline" />
            <CircleButton icon={MdAdd} size="lg" variant="outline" />
          </div>
          <div className="flex gap-4">
            <CircleButton icon={MdAdd} size="xs" variant="ghost" />
            <CircleButton icon={MdAdd} size="sm" variant="ghost" />
            <CircleButton icon={MdAdd} size="md" variant="ghost" />
            <CircleButton icon={MdAdd} size="lg" variant="ghost" />
          </div>
          <div className="flex gap-4">
            <CircleButton icon={MdAdd} size="xs" label="New" />
            <CircleButton icon={MdAdd} size="sm" label="New" />
            <CircleButton icon={MdAdd} size="md" label="New" />
            <CircleButton icon={MdAdd} size="lg" label="New" />
          </div>
          <div className="flex gap-4">
            <CircleButton
              icon={MdAdd}
              size="xs"
              variant="outline"
              label="New"
            />
            <CircleButton
              icon={MdAdd}
              size="sm"
              variant="outline"
              label="New"
            />
            <CircleButton
              icon={MdAdd}
              size="md"
              variant="outline"
              label="New"
            />
            <CircleButton
              icon={MdAdd}
              size="lg"
              variant="outline"
              label="New"
            />
          </div>
          <div className="flex gap-4">
            <CircleButton icon={MdAdd} size="xs" variant="ghost" label="New" />
            <CircleButton icon={MdAdd} size="sm" variant="ghost" label="New" />
            <CircleButton icon={MdAdd} size="md" variant="ghost" label="New" />
            <CircleButton icon={MdAdd} size="lg" variant="ghost" label="New" />
          </div>
          <div className="flex gap-4">
            <CircleButton
              icon={MdAdd}
              size="xs"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="sm"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="md"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="lg"
              label="New"
              iconPosition="right"
            />
          </div>
          <div className="flex gap-4">
            <CircleButton
              icon={MdAdd}
              size="xs"
              variant="outline"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="sm"
              variant="outline"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="md"
              variant="outline"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="lg"
              variant="outline"
              label="New"
              iconPosition="right"
            />
          </div>
          <div className="flex gap-4">
            <CircleButton
              icon={MdAdd}
              size="xs"
              variant="ghost"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="sm"
              variant="ghost"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="md"
              variant="ghost"
              label="New"
              iconPosition="right"
            />
            <CircleButton
              icon={MdAdd}
              size="lg"
              variant="ghost"
              label="New"
              iconPosition="right"
            />
          </div>
          </div>
        </LabeledField>
        <LabeledField
  label={"Circle Buttons - Secondary:"}
  id={"secondary-circle-buttons"}
  className="heading-md "
>
  <div className="flex flex-col gap-2 py-2">
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" color="secondary" />
      <CircleButton icon={MdAdd} size="md" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" color="secondary" />
      <CircleButton icon={MdAdd} size="md" variant="outline" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" color="secondary" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="md" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" label="New" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="md" variant="outline" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" label="New" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" label="New" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" label="New" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="md" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" label="New" iconPosition="right" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="md" variant="outline" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" label="New" iconPosition="right" color="secondary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" label="New" iconPosition="right" color="secondary" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" label="New" iconPosition="right" color="secondary" />
    </div>
  </div>
</LabeledField>
<LabeledField
  label={"Circle Buttons - Tertiary:"}
  id={"tertiary-circle-buttons"}
  className="heading-md "
>
  <div className="flex flex-col gap-2 py-2">
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" variant="outline" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" label="New" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" variant="outline" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" label="New" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" label="New" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" label="New" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" label="New" iconPosition="right" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" variant="outline" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" label="New" iconPosition="right" color="tertiary" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" label="New" iconPosition="right" color="tertiary" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" label="New" iconPosition="right" color="tertiary" />
    </div>
  </div>
</LabeledField>
<LabeledField
  label={"Circle Buttons - White:"}
  id={"white-circle-buttons"}
  className="heading-md "
>
  <div className="flex flex-col gap-2 py-2 bg-gray-800">
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" color="white" />
      <CircleButton icon={MdAdd} size="sm" color="white" />
      <CircleButton icon={MdAdd} size="md" color="white" />
      <CircleButton icon={MdAdd} size="lg" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" color="white" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" color="white" />
      <CircleButton icon={MdAdd} size="md" variant="outline" color="white" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" color="white" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" color="white" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" color="white" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" label="New" color="white" />
      <CircleButton icon={MdAdd} size="sm" label="New" color="white" />
      <CircleButton icon={MdAdd} size="md" label="New" color="white" />
      <CircleButton icon={MdAdd} size="lg" label="New" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" label="New" color="white" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" label="New" color="white" />
      <CircleButton icon={MdAdd} size="md" variant="outline" label="New" color="white" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" label="New" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" label="New" color="white" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" label="New" color="white" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" label="New" color="white" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" label="New" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="sm" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="md" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="lg" label="New" iconPosition="right" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="outline" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="sm" variant="outline" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="md" variant="outline" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="lg" variant="outline" label="New" iconPosition="right" color="white" />
    </div>
    <div className="flex gap-4">
      <CircleButton icon={MdAdd} size="xs" variant="ghost" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="sm" variant="ghost" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="md" variant="ghost" label="New" iconPosition="right" color="white" />
      <CircleButton icon={MdAdd} size="lg" variant="ghost" label="New" iconPosition="right" color="white" />
    </div>
  </div>
</LabeledField>


      </GenericCard>
      <ProfileCard title="Text" description="Typography">
        <>To Do</>
      </ProfileCard>
      <ProfileCard title="Dialogs" description="Example">
        <>To Do</>
      </ProfileCard>
      <ProfileCard title="Toaster" description="Examples">
        <div className="mt-4 flex gap-5">
          <GenericButton
            variant={"solid"}
            size="lg"
            text={"Success"}
            onClick={() => {
              notifySimple("Success", "success");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"solid"}
            size="md"
            text={"Error"}
            onClick={() => {
              notifySimple("Error", "error");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"solid"}
            size="sm"
            text={"Warning"}
            onClick={() => {
              notifySimple("Warning", "warning");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"solid"}
            size="xs"
            text={"Info"}
            onClick={() => {
              notifySimple("Success", "info");
            }}
            color="secondary"
          />
        </div>
        <div className="mt-4 flex gap-5">
          <GenericButton
            variant={"outline"}
            size="lg"
            text={"Success"}
            onClick={() => {
              notifySimple("Success", "success");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"outline"}
            size="md"
            text={"Error"}
            onClick={() => {
              notifySimple("Error", "error");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"outline"}
            size="sm"
            text={"Warning"}
            onClick={() => {
              notifySimple("Warning", "warning");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"outline"}
            size="xs"
            text={"Info"}
            onClick={() => {
              notifySimple("Success", "info");
            }}
            color="secondary"
          />
        </div>
        <div className="mt-4 flex gap-5">
          <GenericButton
            variant={"ghost"}
            size="lg"
            text={"Success"}
            onClick={() => {
              notifySimple("Success", "success");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"ghost"}
            size="md"
            text={"Error"}
            onClick={() => {
              notifySimple("Error", "error");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"ghost"}
            size="sm"
            text={"Warning"}
            onClick={() => {
              notifySimple("Warning", "warning");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"ghost"}
            size="xs"
            text={"Info"}
            onClick={() => {
              notifySimple("Success", "info");
            }}
            color="secondary"
          />
        </div>
        <div className="mt-4 flex gap-5">
          <GenericButton
            variant={"link"}
            size="lg"
            text={"Success"}
            onClick={() => {
              notifySimple("Success", "success");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"link"}
            size="md"
            text={"Error"}
            onClick={() => {
              notifySimple("Error", "error");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"link"}
            size="sm"
            text={"Warning"}
            onClick={() => {
              notifySimple("Warning", "warning");
            }}
            color="secondary"
          />
          <GenericButton
            variant={"link"}
            size="xs"
            text={"Info"}
            onClick={() => {
              notifySimple("Success", "info");
            }}
            color="secondary"
          />
        </div>
      </ProfileCard>
      <ProfileCard title="Loaders" description="Example">
        <>To Do</>
      </ProfileCard>
    </div>
  );
};

export default Widgets;
